/* eslint-disable react/no-danger */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { ButtonType } from 'src/enums/ButtonType'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
// import styles from './illogicalFlowOverlay.module.scss'
import { Button, type ButtonProps } from '../AutoWidgetButton/button'

interface IconProps {
  src: string
  alt: string
}

interface IllogicalFlowOverlayProps {
  regNo: string
  icon?: IconProps
  heading: string
  subHeading?: string
  primaryCta: ButtonProps
  secondaryCta?: ButtonProps
  onClose: Function
  onCloseCtaSegmentEventName?: string
  onCloseCtaSegmentEventProps?: object
  combinedStyles?: any
}

const IllogicalFlowOverlay = ({
  regNo,
  icon,
  heading,
  subHeading,
  primaryCta,
  secondaryCta,
  onClose,
  onCloseCtaSegmentEventName,
  onCloseCtaSegmentEventProps,
  combinedStyles,
}: IllogicalFlowOverlayProps) => (
  <>
    {combinedStyles && (
      <div
        id="auto-widget-illogical-flow-styles"
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{ __html: combinedStyles['illogicalFlowOverlay.module.scss'] }}
      />
    )}
    <div className="illogicalFlowRootContainer">
      <div className="illogicalFlowOverlayContainer">
        <Image
          className="illogicalFlowCrossIcon"
          src="https://acko-cms.ackoassets.com/Close_cross_6b419a9bac.svg"
          alt="Cross icon"
          width={24}
          height={24}
          onClick={() => {
            trackEvent(onCloseCtaSegmentEventName, { ...onCloseCtaSegmentEventProps })
            onClose()
          }}
        />
        <div className="illogicalFlowOverlayDetails">
          <div className="illogicalFlowOverlayHeader">
            {icon?.src ? (
              <Image src={icon?.src} alt={icon?.alt || ''} className="illogicalFlowOverlayIcon" width={0} height={0} />
            ) : null}
            <div className="illogicalFlowRegNoContainer">{regNo}</div>
          </div>
          <div className="illogicalFlowOverlayInfo">
            <div className="illogicalFlowHeading">{heading}</div>
            <div className="illogicalFlowSubHeading">{subHeading}</div>
          </div>
        </div>
        <div className="illogicalFlowCtaContainer">
          {secondaryCta ? <Button type={ButtonType.White} {...secondaryCta} /> : null}
          <Button type={ButtonType.Green} {...primaryCta} />
        </div>
      </div>
    </div>
  </>
)

export default IllogicalFlowOverlay
